<template>

  <div>

    <!-- page-heading -->
    <page-heading pageTitle="PHARMACIES-HEADER"></page-heading>

    <pharmacies
      ref="pharmacies"
      apiURL="site/all"
      routeDetailName="apotheke"
      :showSearch="true"
      :activeFilters="['apopoint', 'apokat']"
      :tblColumns="['id', 'extRef', 'name', 'location', 'apopoint', 'apokat']"
      :tblSortColumns="['extRef', 'name', 'location', 'apopoint', 'apokat']"
      :tblOptions="{ perPage: 15 }">
    </pharmacies>

  </div>

</template>




<script>
import pharmacies from '../utils/incl-pharmacies';

export default {

  name: 'Apotheken',

	components: {
    pharmacies
	},

	data() {
		return {
    }
  }
}

</script>


<style lang="scss" scoped>

</style>
